export const DEVICE_TYPE_MAP = {
  PNWX: {
    name: '手机宝',
    num: 100,
    icon: require('@/assets/images/addDevice/softnode/phone.png'),
  },
  PCWX: {
    name: '电脑宝',
    num: 100,
    icon: require('@/assets/images/addDevice/softnode/zqb-lite.png'),
  },
  nas: {
    name: 'nas小星',
    num: 200,
    icon: require('@/assets/images/addDevice/softnode/nas.png'),
  },
  DC: {
    name: '容器魔方',
    num: 200,
    icon: require('@/assets/images/addDevice/softnode/container.png'),
  },
};
